import t1 from "../assets/testimonials/Madhuri.png";
import t2 from "../assets/testimonials/Priyanka.png";
import t3 from "../assets/testimonials/Richa.jpg";
import t4 from "../assets/testimonials/poonam.jpg";

import newClient1 from "../assets/testimonials/8T6A0714.jpg";
import newClient2 from "../assets/testimonials/8T6A0714 (1).jpg";
import newClient3 from "../assets/testimonials/8T6A0714 (2).jpg";

export const home = {
  page: [
    {
      title: "Financing ambition. Empowering women. Building futures.",
      description:
        "BSS Sonata facilitates microcredit to women borrowers on behalf of Kotak Mahindra Bank Ltd. (KMBL), supporting sustainable income generation and contributing to an improved quality of life of customer households. By leveraging structured processes, advanced technology, and focused training, we ensure the consistent delivery of high-quality services to KMBL’s microcredit borrowers. The Company distributes small loans that begin at Rs. 5,000 to Rs. 1,00,000 to poor women so they can start and expand simple businesses and increase their incomes.",
      heroImagePositionMobile: "80% 30%",
      loanRange: {
        min: 2000,
        max: 100000,
        currency: "INR",
      },
      highlights: [
        {
          title: "Loan services",
          description:
            "Microcredit from ₹5,000 to ₹1,00,000 with flexible repayment choices.",
        },
        {
          title: "28 years of expertise",
          description:
            "Decades of financial services experience directed at rural entrepreneurs.",
        },
      ],
      cta: {
        text: "Learn more about us",
        link: "/about",
        icon: "→",
      },
    },
    {
      title: "Happy Clients",
      sections: [
        {
          id: 3,
          heading: "Changed Lives, Proven Expertise",
          list: [
            {
              id: 5,
              name: "Radha",
              massage:
                "Radha invested her loan in a stove and bulk ingredients for her snack business. Her daughter now helps with packing, and they supply two neighbouring streets.",
              image: newClient1,
              bgColor: "bg-red",
            },
            {
              id: 6,
              name: "Aarti",
              massage:
                "A small working-capital loan helped Aarti buy moulds and raw materials. Her soaps are sold through local WhatsApp groups, giving her a steady side income.",
              image: newClient2,
              bgColor: "bg-red",
            },
            {
              id: 7,
              name: "Priyanka",
              massage:
                "Priyanka used her microloan to set up a tiny beauty corner in her living room. Neighbourhood clients now provide her with reliable weekly earnings.",
              image: newClient3,
              bgColor: "bg-red",
            },
            {
              id: 1,
              name: "Reena",
              massage:
                "With a small loan, Reena bought her first sewing machine. She now stitches blouses and school uniforms from home, supporting her family’s monthly expenses.",
              image: t1,
              bgColor: "bg-red",
            },
            {
              id: 2,
              name: "Lata",
              massage:
                "A microloan helped Lata add a steel counter and better supplies to her tea stall. Her daily income improved enough to comfortably manage household needs.",
              image: t2,
              bgColor: "bg-red",
            },
            {
              id: 3,
              name: "Meenakshi",
              massage:
                "Meenakshi used her loan to buy a second vegetable cart. Her husband now helps her sell in nearby lanes, doubling their family earnings.",
              image: t3,
              bgColor: "bg-red",
            },
            {
              id: 4,
              name: "Sushila",
              massage:
                "With her first livestock loan, Sushila purchased a buffalo. The extra milk she sells each morning now pays for her children’s school notebooks and fees.",
              image: t4,
              bgColor: "bg-red",
            },
          ],
        },
      ],
    },
  ],
};
